import type { WorkingDayKey } from '../WorkingDays/WorkingDays.types'

export type DayTimePeriod = 'AM' | 'PM'

export type DayTimeParts = {
  hour: string
  minute: string
  period: DayTimePeriod
}

export type DayTimeSelectorValue = {
  days: WorkingDayKey[]
  start: DayTimeParts | null
  end: DayTimeParts | null
}

export type DayTimeSelectorPreviewState =
  | 'default'
  | 'filled'
  | 'open'
  | 'disabled'

export const DAY_TIME_SELECTOR_PREVIEW_STATES: DayTimeSelectorPreviewState[] = [
  'default',
  'filled',
  'open',
  'disabled',
]

export const DAY_TIME_SELECTOR_PREVIEW_STATE_LABELS: Record<
  DayTimeSelectorPreviewState,
  string
> = {
  default: 'Default',
  filled: 'Filled',
  open: 'Open',
  disabled: 'Disabled',
}

export const DAY_TIME_SELECTOR_PERIODS: DayTimePeriod[] = ['AM', 'PM']

export const DAY_TIME_SELECTOR_DEMO_VALUE: DayTimeSelectorValue = {
  days: ['mon', 'tue', 'wed', 'thu', 'fri'],
  start: { hour: '9', minute: '00', period: 'AM' },
  end: { hour: '5', minute: '00', period: 'PM' },
}

export const EMPTY_DAY_TIME_SELECTOR_VALUE: DayTimeSelectorValue = {
  days: [],
  start: null,
  end: null,
}

export type DayTimeSelectorProps = {
  label?: string
  placeholder?: string
  value?: DayTimeSelectorValue
  defaultValue?: DayTimeSelectorValue
  disabled?: boolean
  darkMode?: boolean
  className?: string
  /** Static visual state for the design-system showcase only. */
  previewState?: DayTimeSelectorPreviewState
  daysLabel?: string
  startLabel?: string
  endLabel?: string
  onChange?: (value: DayTimeSelectorValue) => void
  onOpenChange?: (open: boolean) => void
}
